/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Efatura_Earsiv_FarkiInputs */

const tr_faq_a_efatura_earsiv_farki = /** @type {(inputs: Faq_A_Efatura_Earsiv_FarkiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşterinin VKN'si e-Fatura mükellefi olarak kayıtlıysa sistem otomatik olarak e-Fatura keser ve elektronik ortamda iletir. VKN yoksa veya mükellefiyet bulunmuyorsa e-Arşiv fatura düzenlenir. Bu seçim arka planda otomatik yapılır, sen ekstra bir şey yapman gerekmez.`)
};

const en_faq_a_efatura_earsiv_farki = /** @type {(inputs: Faq_A_Efatura_Earsiv_FarkiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the customer's tax ID is registered as an e-Fatura taxpayer, the system issues an e-Fatura and delivers it electronically. Otherwise an e-Arsiv (e-Archive) invoice is issued. The selection is automatic.`)
};

const de_faq_a_efatura_earsiv_farki = /** @type {(inputs: Faq_A_Efatura_Earsiv_FarkiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist die Steuer-ID des Kunden als e-Fatura-Steuerpflichtiger registriert, wird automatisch eine e-Fatura ausgestellt und elektronisch übermittelt. Ansonsten wird eine e-Arsiv (e-Archiv)-Rechnung erstellt. Die Auswahl erfolgt automatisch.`)
};

const ru_faq_a_efatura_earsiv_farki = /** @type {(inputs: Faq_A_Efatura_Earsiv_FarkiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если ИНН покупателя зарегистрирован как плательщик e-Fatura, система автоматически выставляет электронный счёт и отправляет его. Иначе создаётся e-Arsiv (электронный архив) счёт. Выбор происходит автоматически.`)
};

/**
* | output |
* | --- |
* | "If the customer's tax ID is registered as an e-Fatura taxpayer, the system issues an e-Fatura and delivers it electronically. Otherwise an e-Arsiv (e-Archive..." |
*
* @param {Faq_A_Efatura_Earsiv_FarkiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_efatura_earsiv_farki = /** @type {((inputs?: Faq_A_Efatura_Earsiv_FarkiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Efatura_Earsiv_FarkiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_efatura_earsiv_farki(inputs)
	if (locale === "de") return de_faq_a_efatura_earsiv_farki(inputs)
	if (locale === "ru") return ru_faq_a_efatura_earsiv_farki(inputs)
	return tr_faq_a_efatura_earsiv_farki(inputs)
});